import { faImage } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import styled from "styled-components";

interface ActivityImageProps {
  isAdded?: boolean;
  src?: string | null;
  title: string;
}

export const ActivityImage: React.FC<ActivityImageProps> = ({ isAdded, src, title }) => {
  return (
    <ImageContainer className={clsx({ added: isAdded })}>
      {src ? <img src={src} alt={title} /> : <FontAwesomeIcon icon={faImage} />}
    </ImageContainer>
  );
};

const ImageContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  min-width: 52px;
  min-height: 52px;
  padding: 4px;
  color: ${({ theme }) => theme.colors.redesign.db30};
  background-color: ${({ theme }) => theme.colors.redesign.db1};
  border-radius: 8px;

  img,
  svg {
    width: 100%;
    height: auto;
  }

  &.added {
    background-color: transparent;
  }
`;
